import {errorMessageAlert} from '@/helpers/alert'

/**
* @param key {string} the key you want to store the value with.
* @param value {JSON} the object you want to serialize into localstorage.
*/
export const setItem = (key, value) => {
  window.localStorage.setItem(key, JSON.stringify(value))
}

/**
* @param key {string} the key you want to retrieve the value from.
*/
export const getItem = (key) => {
  return JSON.parse(window.localStorage.getItem(key))
}

/* @author TLV 07/08/2020
* @brief Fonction updateToSeen pour marquer un message comme lu, en utilisant
*       le nouvel événement créé dans menuItem.vue
* @details à adapter à toutes les pages où la fonction updateToSeen a été écrite en dur
*/
export const updateToSeen = (element, payId, serviceName) => {
  let that = element
  that.$engine.services[serviceName]
    .setPaymentsRead({
      id: payId,
      isRead: 1
    })
    .then(response => {
      that.$engine.services[serviceName].getPaymentsNotReadNumber().then(resp => {
        that.$bus.emit('updateNotificationNumber', resp.data.requestNotReadNumber)
        // cordova.plugins.notification.badge.set(resp.data.requestNotReadNumber)
      })
      .catch(error => {
        // console.log(error)
        errorMessageAlert(error, that)
      })
    })
    .catch(error => {
      that.$f7.hidePreloader()
      errorMessageAlert(error, that)
    })
}
